(() => {
  const attribute = 'Student / Recipient Name(s)';
  let draft;
  let dirty = false;
  let timer;
  let queue = Promise.resolve();
  const resumed = new WeakSet();
  const busy = new WeakSet();
  const fields = () => [...document.querySelectorAll('retail-recipient-name')];
  const inputOf = (field) => field.querySelector('input');
  function message(text, invalid = false) {
    fields().forEach((field) => {
      const error = field.querySelector('[data-recipient-error]');
      error.textContent = text;
      error.hidden = !text;
      inputOf(field).setAttribute('aria-invalid', String(invalid));
    });
  }
  function save() {
    clearTimeout(timer);
    // Serialize writes so an older request cannot overwrite a newer name.
    const value = draft;
    const operation = queue.catch(() => {}).then(async () => {
      const response = await fetch(window.routes.cart_update_url + '.js', {
        method: 'POST', credentials: 'same-origin', keepalive: true,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { [attribute]: value } }),
      });
      if (!response.ok) throw new Error('Recipient name could not be saved. Please try again before checkout.');
      const cart = await response.json();
      if ((cart.attributes?.[attribute] || '') !== value) throw new Error('Recipient name could not be saved. Please try again before checkout.');
      if (draft === value) dirty = false;
    });
    queue = operation;
    return operation;
  }
  customElements.define('retail-recipient-name', class extends HTMLElement {
    connectedCallback() {
      const input = inputOf(this);
      if (dirty) input.value = draft;
      else draft = input.value;
      this.addEventListener('input', () => {
        draft = input.value;
        dirty = true;
        input.setCustomValidity('');
        message('');
        fields().forEach((field) => { if (field !== this) inputOf(field).value = draft; });
        clearTimeout(timer);
        timer = setTimeout(() => save().catch((error) => message(error.message)), 250);
      });
      // Drawer quantity handlers must not interpret this input as a variant quantity.
      this.addEventListener('change', (event) => {
        event.stopPropagation();
        save().catch((error) => message(error.message));
      });
    }
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const button = event.submitter;
    if (button?.name !== 'checkout' || resumed.has(form)) return;
    const field = fields().find((item) => inputOf(item).form === form);
    if (!field) return; // Empty and quote-only carts retain their existing behavior.
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy.has(form)) return;
    const input = inputOf(field);
    draft = input.value;
    if (!draft.trim()) {
      input.setCustomValidity('Please enter the student / recipient name(s).');
      message('Please enter the student / recipient name(s).', true);
      input.focus();
      input.reportValidity();
      return;
    }
    busy.add(form);
    try {
      await save();
      // Do not submit a stale name if the customer edited it during the request.
      while (dirty) await save();
      if (!inputOf(field).value.trim()) return;
      resumed.add(form);
      form.requestSubmit(button);
      resumed.delete(form);
    } catch (error) {
      message(error.message, true);
      input.focus();
    } finally {
      busy.delete(form);
    }
  }, true);
})();
